import DeliveryOptionProductPreview
from '../../../sections/DeliveryOptionSection/DeliveryOptionProductPreview/DeliveryOptionProductPreview';
import OpenpayOverlay
from '../../../sections/PaymentOptionsSection/PaymentOptions/Openpay/OpenpayOverlay/OpenpayOverlay';
import SezzleOverlay from '../../../sections/PaymentOptionsSection/PaymentOptions/Sezzle/SezzleOverlays/SezzleOverlay';
import SplititOverlay
from '../../../sections/PaymentOptionsSection/PaymentOptions/Splitit/SplititOverlay/SplititOverlay';
import SpotiiOverlay from '../../../sections/PaymentOptionsSection/PaymentOptions/Spotii/SpotiiOverlay/SpotiiOverlay';
import ZippayOverlay from '../../../sections/PaymentOptionsSection/PaymentOptions/Zippay/ZippayOverlay/ZippayOverlay';
import {TooltipAndOverlayIDs} from '../detailed-tooltip/TooltipLibrary';
import FastTrackInfo from '../FastTrackInfo/FastTrackInfo';
import ImportTaxHelpOverlay from '../ImportTax/ImportTaxHelpOverlay';
import ThreeDSecureOverlay from '../ThreeDSecure/ThreeDSecureOverlay';
import AdyenV2ActionOverlay from './custom-overlays/AdyenV2/AdyenV2ActionOverlay';
import AfterPayClearPayOverlay from './custom-overlays/AfterPayClearPayOverlay/AfterPayClearPayOverlay';
import BrazilianResidentIDOverlay from './custom-overlays/BrazilianResidentIDOverlay';
import ChineseResidentIDOverlay from './custom-overlays/ChineseResidentIDOverlay';
import ContactNumberOverlay from './custom-overlays/ContactNumberOverlay';
import CV2Overlay from './custom-overlays/CV2Overlay';
import DeliveryInformationOverlay from './custom-overlays/DeliveryInformationOverlay';
import DeleteAddressOverlay from './custom-overlays/EditDeleteAddressOverlay/DeleteAddressOverlay';
import EditAddressOverlay from './custom-overlays/EditDeleteAddressOverlay/EditAddressOverlay';
import EditDeleteAddressOverlay from './custom-overlays/EditDeleteAddressOverlay/EditDeleteAddressOverlay';
import EditDeleteAddressSuccessOverlay
from './custom-overlays/EditDeleteAddressOverlay/EditDeleteAddressSuccessOverlay';
import EditDeliveryAddressOverlay from './custom-overlays/EditDeliveryAddressOverlay';
import SubscriptionOverlay from './custom-overlays/SubscriptionOverlay/SubscriptionInformationOverlay';
import KlarnaOverlay from './custom-overlays/KlarnaOverlay';
import RemoveGiftcardOverlay from './custom-overlays/RemoveGiftcardOverlay';
import ResidentIdDeliveryDescriptionOverlay from './custom-overlays/ResidentIdDeliveryDescriptionOverlay';
import KoreanPassportNumberOverlay from './custom-overlays/PassportNumberOverlay';
import KoreanPCCCOverlay from './custom-overlays/PCCCOverlay';
import ModeOverlay from './custom-overlays/ModeOverlay/ModeOverlay';
import OrderProcessingOverlay from './custom-overlays/OrderProcessingOverlay';
import OrderSummaryOverlay from './custom-overlays/OrderSummaryOverlay';
import PayerNameOverlay from './custom-overlays/PayerNameOverlay';
import PayVyneOverlay from './custom-overlays/PayVyneOverlay/PayVyneOverlay';
import PostalIdInfoOverlay from './custom-overlays/PostalIdInfoOverlay';
import PudoOverlay from './custom-overlays/PudoOverlay';
import CollectionOverlay from './custom-overlays/CollectionOverlay';
import FrasersPlusOverlay from './custom-overlays/FrasersPlusOverlay/FrasersPlusOverlay';
import TrustlyOverlay from './custom-overlays/TrustlyOverlay/TrustlyOverlay';
import WeChatOverlayLazyLoader from './custom-overlays/WeChatOverlay/WeChatOverlayLazyLoader';

export class OverlayComponent {
  constructor(component, props) {
    this.component = component;
    this.props = props;
  }
}

export function getOverlay(overlay) {
  const overlays = {
    [TooltipAndOverlayIDs.AFTERPAY_CLEARPAY]: new OverlayComponent(AfterPayClearPayOverlay),
    [TooltipAndOverlayIDs.FRASERS_PLUS]: new OverlayComponent(FrasersPlusOverlay),
    pudo: new OverlayComponent(PudoOverlay, {lang: overlay.overlayData}),
    [TooltipAndOverlayIDs.COLLECTION]: new OverlayComponent(CollectionOverlay, {lang: overlay.overlayData}),
    order_processing: new OverlayComponent(OrderProcessingOverlay, {...overlay.overlayData}),
    wechat: new OverlayComponent(WeChatOverlayLazyLoader, {url: overlay.overlayData}),
    [TooltipAndOverlayIDs.KLARNA]: new OverlayComponent(KlarnaOverlay),
    [TooltipAndOverlayIDs.CV2_TOOLTIP]: new OverlayComponent(CV2Overlay),
    [TooltipAndOverlayIDs.CONTACT_NUMBER_INFO]: new OverlayComponent(ContactNumberOverlay),
    [TooltipAndOverlayIDs.POSTAL_ID_INFO]: new OverlayComponent(PostalIdInfoOverlay),
    [TooltipAndOverlayIDs.CHINESE_RESIDENT_ID]: new OverlayComponent(ChineseResidentIDOverlay),
    [TooltipAndOverlayIDs.PAYER_NAME]: new OverlayComponent(PayerNameOverlay),
    [TooltipAndOverlayIDs.IMPORT_TAX]: new OverlayComponent(ImportTaxHelpOverlay),
    fast_track_info: new OverlayComponent(FastTrackInfo),
    [TooltipAndOverlayIDs.ORDERSUMMARY]: new OverlayComponent(OrderSummaryOverlay),
    delivery_option_product_preview:
      new OverlayComponent(DeliveryOptionProductPreview, {...overlay.overlayData}),
    [TooltipAndOverlayIDs.EDIT_DELIVERY_ADDRESS]: new OverlayComponent(EditDeliveryAddressOverlay),
    [TooltipAndOverlayIDs.BRAZILIAN_RESIDENT_ID]: new OverlayComponent(BrazilianResidentIDOverlay),
    [TooltipAndOverlayIDs.SUBSCRIPTION]: new OverlayComponent(SubscriptionOverlay, {...overlay.overlayData}),
    [TooltipAndOverlayIDs.KOREAN_PCC_NUMBER]: new OverlayComponent(KoreanPCCCOverlay),
    [TooltipAndOverlayIDs.KOREAN_PASSPORT_NUMBER]: new OverlayComponent(KoreanPassportNumberOverlay),
    [TooltipAndOverlayIDs.RESIDENT_ID_DELIVERY_DESCRIPTION]: new OverlayComponent(ResidentIdDeliveryDescriptionOverlay),
    [TooltipAndOverlayIDs.DELIVERY_INFORMATION]: new OverlayComponent(DeliveryInformationOverlay),
    [TooltipAndOverlayIDs.THREE_D_SECURE]:
      new OverlayComponent(ThreeDSecureOverlay),
    [TooltipAndOverlayIDs.ADYEN_V2_ACTION]:
      new OverlayComponent(AdyenV2ActionOverlay, {action: overlay.overlayData}),
    [TooltipAndOverlayIDs.SPLITIT]: new OverlayComponent(SplititOverlay),
    [TooltipAndOverlayIDs.OPENPAY]: new OverlayComponent(OpenpayOverlay),
    [TooltipAndOverlayIDs.ZIPPAY]: new OverlayComponent(ZippayOverlay),
    [TooltipAndOverlayIDs.SEZZLE]: new OverlayComponent(SezzleOverlay),
    [TooltipAndOverlayIDs.MODE]: new OverlayComponent(ModeOverlay),
    [TooltipAndOverlayIDs.EDIT_DELETE_ADDRESS]: new OverlayComponent(EditDeleteAddressOverlay, {...overlay.overlayData}),
    [TooltipAndOverlayIDs.EDIT_ADDRESS]: new OverlayComponent(EditAddressOverlay, {...overlay.overlayData}),
    [TooltipAndOverlayIDs.DELETE_ADDRESS]: new OverlayComponent(DeleteAddressOverlay, {...overlay.overlayData}),
    [TooltipAndOverlayIDs.EDIT_DELETE_ADDRESS_SUCCESS]: new OverlayComponent(EditDeleteAddressSuccessOverlay, {...overlay.overlayData}),
    [TooltipAndOverlayIDs.PAYVYNE]: new OverlayComponent(PayVyneOverlay),
    [TooltipAndOverlayIDs.TRUSTLY]: new OverlayComponent(TrustlyOverlay),
    [TooltipAndOverlayIDs.SPOTII]: new OverlayComponent(SpotiiOverlay),
    [TooltipAndOverlayIDs.REMOVE_GIFTCARD]: new OverlayComponent(RemoveGiftcardOverlay, {...overlay.overlayData}),
  };
  return overlays[overlay.selectedOverlay];
}
